import React from 'react';
import { useNavigate } from 'react-router-dom';
import s from './ValuePropositionSection.module.css';
import {
    OptimizedMotion,
    OptimizedMotionH2,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const ValuePropositionSection: React.FC = () => {
    const navigate = useNavigate();

    const handleStartCreating = () => {
        navigate('/contact');
    };

    return (
        <section className={s.container}>
            <div className={s.content}>
                <OptimizedMotionH2 type="slide-down" delay={0.3} className={s.mainTitle}>
                    Every bad visual hurts <span className={s.highlight}>your brand</span>
                </OptimizedMotionH2>

                <div className={s.cardsContainer}>
                    <div className={s.card}>
                        <OptimizedMotionH2 type="slide-up" delay={0.8} className={s.cardTitle}>
                            YOUR TIME
                        </OptimizedMotionH2>
                        <OptimizedMotionP type="slide-up" delay={1.0} className={s.cardText}>
                            Stop wasting hours editing, designing, or waiting on agencies. Create
                            on-brand content that's ready to post in seconds.
                        </OptimizedMotionP>
                    </div>

                    <div className={s.card}>
                        <OptimizedMotionH2 type="slide-up" delay={1.2} className={s.cardTitle}>
                            YOUR MONEY
                        </OptimizedMotionH2>
                        <OptimizedMotionP type="slide-up" delay={1.2} className={s.cardText}>
                            You're losing sales to brands that simply look more professional — even
                            when their products aren't better.
                        </OptimizedMotionP>
                    </div>

                    <div className={s.card}>
                        <OptimizedMotionH2 type="slide-up" delay={1.4} className={s.cardTitle}>
                            YOUR CUSTOMERS
                        </OptimizedMotionH2>
                        <OptimizedMotionP type="slide-up" delay={1.4} className={s.cardText}>
                            When your visuals blend in, your brand disappears. Let SimpleeCreate
                            make it impossible to ignore.
                        </OptimizedMotionP>
                    </div>
                </div>

                <div className={s.ctaBlock}>
                    <div className={s.ctaContent}>
                        <OptimizedMotionH2 type="slide-down" delay={1.2} className={s.ctaTitle}>
                            People buy what looks better — make sure it's you
                        </OptimizedMotionH2>
                        <OptimizedMotionP type="slide-down" delay={1.2} className={s.ctaSubtitle}>
                            With SimpleeCreate, every post, ad, and product shot looks on-brand,
                            professional, and ready to sell.
                        </OptimizedMotionP>
                    </div>
                    <OptimizedMotion
                        type="slide-right"
                        delay={1.4}
                        className={s.ctaButton}
                        onClick={handleStartCreating}
                    >
                        Request Early Access
                    </OptimizedMotion>
                </div>
            </div>
        </section>
    );
};

export default ValuePropositionSection;
